<template>
  <div class="yzm-flodselect" :style="{ ...marginStyle }">
    <el-select v-model="value" :placeholder="item.setting.placeholder">
      <el-option v-for="o in item.data" :key="o.value" :value="o.value" :label="o.label" />
    </el-select>
  </div>
</template>
<script setup>
import { defineProps, computed, ref , onMounted, defineEmits} from 'vue'
import { defaultProps } from './defaultProps'
const props = defineProps({
  ...defaultProps
})
const value = ref(null)
const marginStyle = computed(() => {
  let item = props.item.setting
  return {
    marginTop: `${item.marginTop}px`,
    marginBottom: `${item.marginBottom}px`,
    marginLeft: `${item.marginLeft}px`,
    marginRight: `${item.marginRight}px`
  }
})
const emit = defineEmits(['childMounted'])
onMounted(() => {
  emit('childMounted')
})
</script>
<style lang="less" scoped>
.yzm-flodselect {
}
</style>
